import { connect } from 'react-redux';
import { Instances, SideBarTypes } from '../../../constants';

import { IStateType } from '../../../store/models/root.interface';
import { requestObject } from '../../../store/Object/actions';

import { makeSelectObject } from '../../../store/Object/selectors';

import CustomerNumber, {
	DispatchPropsType,
	MapStatePropsType,
} from '../organisms/StickyAgentModal/customerNumber';

const mapStateToProps = () => {
	const selectData = makeSelectObject(Instances.StickyAgentFilters);
	return (state: IStateType) => ({
		selectData: selectData(state),
	});
};
const mapDispatchToProps = {
	validateNumber: (data: any, cb: (res: any) => void) =>
		requestObject(
			Instances.validateNumbers,
			undefined,
			undefined,
			'POST',
			true,
			true,
			data,
			cb
		),
	fetchFilters: (cb: any) =>
		requestObject(
			Instances.StickyAgentFilters,
			undefined,
			undefined,
			'GET',
			true,
			true,
			undefined,
			cb
		),
};

export default connect<
	MapStatePropsType,
	DispatchPropsType,
	unknown,
	IStateType
>(
	mapStateToProps,
	mapDispatchToProps
)(CustomerNumber);
